import { useMutation } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';

import InputControl from '@/components/form/input-control';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import HookFormProvider from '@/providers/hook-form-providers';
import { authMutations } from '@/queries/auth/auth.queries';
import { useDialogStore } from '@/store';
import {
	registerRequest,
	type RegisterRequest
} from '@/types/auth/auth.request';

export const Register = () => {
	const navigate = useNavigate();
	const setDialog = useDialogStore((s) => s.setStore);
	const setAction = useDialogStore((s) => s.setAction);
	const register = useMutation(authMutations.register);

	const handleSubmit = (data: RegisterRequest) => {
		register.mutate(data, {
			onSuccess: () => {
				setAction('onConfirm', () => {
					setDialog('open', false);
					navigate('/', { viewTransition: true, replace: true });
				});
				setDialog('variant', 'success');
				setDialog('title', 'Berhasil');
				setDialog(
					'description',
					<>
						<p>Terimakasih telah melakukan pendaftaran!</p>
						<p>Data Anda akan segera kami proses</p>
					</>
				);
				setDialog('confirmText', 'OK');
				setDialog('open', true);
			},
			onError: ({ message }) => {
				setDialog('variant', 'error');
				setDialog('title', 'Gagal');
				setDialog('description', message);
				setDialog('confirmText', 'OK');
				setDialog('open', true);
			}
		});
	};

	return (
		<div className="flex h-screen w-full items-center justify-center bg-white">
			<Card className="shadow-primary/10 flex h-5/6 flex-row p-0 shadow-lg md:w-3/4">
				<CardContent className="flex w-full flex-col items-center justify-center gap-2 md:w-1/2 md:px-16 lg:px-24">
					<img src="/logo/circle-logo.webp" alt="circle-logo" className="w-40" />
					<h1 className="text-center text-lg font-bold lg:text-xl">
						Daftar Akun Vendor
					</h1>
					<span className="text-label-input text-center">
						Pastikan data yang Anda masukan benar.
					</span>

					<HookFormProvider
						schema={registerRequest}
						onSubmit={handleSubmit}
						className="mt-2 flex w-full flex-col justify-start gap-4"
					>
						<InputControl name="name" label="Nama Perusahaan" required />
						<InputControl name="email" label="Email Perusahaan" required />
						<Button disabled={register.isPending}>Daftar</Button>
					</HookFormProvider>
					<span className="text-label-input text-sm">
						Sudah punya akun?{' '}
						<Link
							to="/login"
							viewTransition
							className="text-primary font-medium underline underline-offset-4"
						>
							Masuk
						</Link>
					</span>
				</CardContent>
				<CardContent className="hidden items-center justify-center rounded-r-xl bg-[url(/image/bg-login.webp)] bg-cover md:flex md:w-1/2">
					<div className="flex h-4/5 w-3/4 flex-col gap-3 rounded-3xl border border-white/50 bg-white/30 px-6 py-6 text-xl font-bold text-white backdrop-blur-xs">
						<span>Platform E-Procurement</span>
						<span>Dari Astra untuk Grup Astra</span>

						<img
							src="/logo/login-1.webp"
							className="absolute -right-12 -bottom-12 size-40 md:size-60 lg:size-80"
							alt="login-1"
						/>
					</div>
				</CardContent>
			</Card>
		</div>
	);
};
